import React, { useEffect } from 'react';
import { CollapseBlock } from '../../../../common/index.jsx';
import { routes } from '../../../../../utils/helpers/ApiClient.jsx';
import LogsTable from './LogsTable.jsx';
import { AppBarCMS } from '../../../../basic/index.jsx';
import { useTranslation } from 'react-i18next';

const LogsPage = () => {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t('Súbor denníka') + ' - FRI CMS';
  }, []); // Runs on mount

  return (
    <>
      <AppBarCMS
        title={t('Súbor denníka')}
        backUrl={routes.cmsDashboard}
        backUrlTooltip={t('Nástenka')}
        permissionsBasic={'logs'}
      />
      <div style={{ margin: '10px' }}>
        <CollapseBlock>
          <LogsTable />
        </CollapseBlock>
      </div>
    </>
  );
};

export default LogsPage;
